import React, { useEffect, useState } from "react";
import { FxTextFieldBase } from "../../fxms/inputs/FxTextField";
import { v4 as uuidv4 } from 'uuid';
import { FxButtonBase } from "../../fxms/inputs/FxButton";
import { FxCheckBoxBase } from "../../fxms/inputs/FxCheckBox";
import { FxDataGridBase } from "../../fxms/components/grid/FxDataGrid";
import { FxForm, FxFormButtons } from "../../fxms/inputs/FxForm";
import { FxFooter } from "../../fxms/inputs/FxFooter";
import { FxWindow } from "../../fxms/windows/FxWindows";
import { FxActionBase } from "../../fxms/actions/FxAction";
import { FxSelectComplex, FxSelectCompany, FxSelectPlant, FxSelectEnergy, FxSelectFacility, FxSelectPipe } from "../inputs/VupInputs";

/**
 * 에너지 경로 추가 / 수정
 * 개발자 : 최선하
 * 개발년월 : 2023.02
 * @param {*} props
 * @returns
 */

export const UI_4_3_CU = (props) => {
  const { isLoaded } = props;
  const [inputDatas, setInputDatas] = React.useState({});
  const [complexInloNo, setComplexInloNo] = React.useState(0);
  const [rows, setRows] = React.useState([]);
  const [selectedData, setSelectedData] = React.useState({});


  function onChangeValue(id, value, object) {
    let newData = { ...inputDatas };
    if (value) {
      newData[id] = value;
    } else {
      delete newData[id];
    }
    setInputDatas(newData);

    if (id == "inloNo") {
      setComplexInloNo(value);
    } else if (id == "pipeId") {
      addPipe2Rt(object);
    }

    // console.log("UI_4_3_CU", newData);
  }

  function addPipe2Rt(pipeInfo) {
    if (pipeInfo) {

      for (let row of rows) {
        if (row.pipeId == pipeInfo.pipeId) {
          FxWindow.alert(pipeInfo.pipeName + '은 이미 등록되어 있습니다.');
          return;
        }
      }

      let tmpRows = [...rows];
      tmpRows.push({ pipeId: pipeInfo.pipeId, pipeName: pipeInfo.pipeName, id: pipeInfo.pipeId });
      setRows(tmpRows);
    }
  }

  function onCellSelected(row) {
  }

  function onClick(name) {
    if (name == 'btnRemove') {
      setRows([]);
    } else if (name == "click") {
      let newDatas = { ...inputDatas };
      newDatas.pipeIdList = [];
      for (let row of rows) {
        newDatas.pipeIdList.push(row.pipeId);
      }

      if (props.selectedDataId) {
        // 수정
        let caller = new FxActionBase("vupEngRoute/engPath/"+ props.selectedDataId, "PUT");
        caller.execute(newDatas, function (bret) {
          console.log("UI_4_3_CU click result ", bret);
        });
      } else {
        // 추가
        let caller = new FxActionBase("vupEngRoute/engPath", "POST");
        caller.execute(newDatas, function (bret) {
          console.log("UI_4_3_CU click result ", bret);
        });
      }
    }
  }

  useEffect(() => {
    
    console.log("UI_4_3_CU", props);

    if (props.selectedData) {

      setSelectedData(props.selectedData);
      setInputDatas(props.selectedData);

      let caller = new FxActionBase("vupEngRoute/engPath/detail/" + props.selectedDataId, "GET");
      caller.select({}, function (bret, datas) {
        if ( bret ) {
          if ( datas.length === 1 ) {
            const routes = datas[0].engRoute.split('|');
            let tmpRows = [];
            for ( let pipeId of routes ) {
              tmpRows.push({ pipeId: pipeId, pipeName: pipeId, id: pipeId});
            }
            setRows(tmpRows);
          }
        }
      });
    

    }
  }, [props.selectedData]);


  if (isLoaded == false) {
    return <></>
  }

  // 그리드 컬럼 설정
  let cols = [];
  cols.push({ field: "pipeId", headerName: "배관ID", width: 200, headerClassName: "DataGridHeader", editable: false, type: "string", });
  cols.push({ field: "pipeName", headerName: "배관명", width: 200, headerClassName: "DataGridHeader", editable: false, type: "string", });

  return (
    <>
      <FxForm style={{ width: '1180px', borderColor: 'green' }}
        cols={['100px', '400px', '100px', '400px']}
        rows={[
          {
            inputs: ["경로명"
              , <FxTextFieldBase name="engRtId" onChangeValue={onChangeValue} selectedData={selectedData}/>
              , "사용여부"
              , <FxCheckBoxBase name="useYn" onChangeValue={onChangeValue} selectedData={selectedData} />
            ]
            , colspan: [1, 1, 1, 1]
          }
          , {
            inputs: ["에너지", <FxSelectEnergy onChangeValue={onChangeValue} selectedData={selectedData} optionText="에너지를 선택하세요"  />
              , "산업단지", <FxSelectComplex onChangeValue={onChangeValue} selectedData={selectedData} optionText="산업단지를 선택하세요" name="inloNo"/>]
            , colspan: [1, 1, 1, 1]
          }

          , {
            inputs: ["SOURCE 공장", <FxSelectPlant onChangeValue={onChangeValue} complexInloNo={complexInloNo} optionText="공장을 선택하세요" name="strtInloNo" selectedData={selectedData} />
              , "설비", <FxSelectFacility onChangeValue={onChangeValue} complexInloNo={complexInloNo} optionText="설비를 선택하세요"  name='strtFacNo' selectedData={selectedData} />]
            , colspan: [1, 1, 1, 1]
          }

          , {
            inputs: ["SINK 공장", <FxSelectPlant onChangeValue={onChangeValue} complexInloNo={complexInloNo} optionText="공장을 선택하세요" name="fnshInloNo" selectedData={selectedData} />
              , "설비", <FxSelectFacility onChangeValue={onChangeValue} complexInloNo={complexInloNo} optionText="설비를 선택하세요" name='fnshFacNo' selectedData={selectedData} />]
            , colspan: [1, 1, 1, 1]
          }
          , {
            inputs: ["배관"
              , <FxSelectPipe onChangeValue={onChangeValue} width="100%" complexInloNo={complexInloNo} optionText="추가할 배관을 선택하세요" />
              , <FxButtonBase name="btnRemove" onClick={onClick} text="모두제거" className="FxButtonSearch" />]
            , colspan: [1, 2, 1]
          }
          , {
            inputs: ["경로", <FxDataGridBase columns={cols} rows={rows} height="200px" onCellSelected={onCellSelected} />]
            , colspan: [1, 3]
            , css: { height: "200px" }
          }
          , {
            inputs: ["메모"
              , <FxTextFieldBase name="engRtDescr" onChangeValue={onChangeValue} selectedData={selectedData} width="100%" />]
            , colspan: [1, 3]
          }
        ]
        }
      >
      </FxForm>
      <FxFormButtons
        right={[<FxButtonBase key={uuidv4()} name="click" onClick={onClick} text="기록" />]}
      />
      <FxFooter />
    </>
  );
}